(ns hai.web-app.viewport
  "Viewport classification (mobile/desktop) derived from `:window/width`."
  (:require
   [hai.ui.rf-sugar :refer [defsub]]))

(def ^:private mobile-max-width 768)

(defsub ::mobile?
  [width :<- [:window/width]]
  ;; `js/window.innerWidth` fallback avoids a one-tick desktop flash before
  ;; `:window/listen-size` writes the initial value to db.
  (let [w (or width (when (exists? js/window) (.-innerWidth js/window)))]
    (boolean (and w (<= w mobile-max-width)))))
